var popularBrand = [
  {
    id: 1,
    image_url:
      "https://onemg.gumlet.io/image/upload/w_150,h_150,c_fit,a_ignore,q_auto,f_auto/v1641187637/lcfd1eufwbtituwyswpi.jpg",
    name: "Covid Essentials",
    link: "https://www.1mg.com/categories/coronavirus-prevention-925",
  },
  {
    id: 2,
    image_url:
      "https://onemg.gumlet.io/image/upload/w_150,h_150,c_fit,a_ignore,q_auto,f_auto/v1642586423/uq1gwxslqqrxxwv6zi6j.jpg",
    name: "Nutritional Drinks",
    link: "https://www.1mg.com/categories/fitness-supplements/family-nutrition-196",
  },
  {
    id: 3,
    image_url:
      "https://onemg.gumlet.io/image/upload/w_150,h_150,c_fit,a_ignore,q_auto,f_auto/v1624525304/kfyx5kvvn2ai5fwswhsa.png",
    name: "Ayurveda",
    link: "https://www.1mg.com/categories/ayurveda-45",
  },
  {
    id: 4,
    image_url:
      "https://onemg.gumlet.io/image/upload/w_150,h_150,c_fit,a_ignore,q_auto,f_auto/v1624525284/cabpuknnlyyzgqfnb4x5.png",
    name: "Vitamins & Supplements",
    link: "https://www.1mg.com/categories/fitness-supplements/vitamins-minerals-9",
  },
  {
    id: 5,
    image_url:
      "https://onemg.gumlet.io/image/upload/w_150,h_150,c_fit,a_ignore,q_auto,f_auto/v1624525168/p1blaka183nc1zlil8tq.png",
    name: "Sexual Wellness",
    link: "https://www.1mg.com/categories/personal-care/sexual-wellness-22",
  },
  {
    id: 6,
    image_url:
      "https://onemg.gumlet.io/image/upload/w_150,h_150,c_fit,a_ignore,q_auto,f_auto/v1624525147/qjfdkz5njmk9n7vvrbb3.png",
    name: "Healthcare Devices",
    link: "https://www.1mg.com/categories/medical-devices-12",
  },
  {
    id: 7,
    image_url:
      "https://onemg.gumlet.io/image/upload/w_150,h_150,c_fit,a_ignore,q_auto,f_auto/v1624525320/j7ruar88gacbzksuadjn.png",
    name: "Homeopathy",
    link: "https://www.1mg.com/categories/homeopathy-57",
  },
];
export default popularBrand;
